export default "__VITE_ASSET__sN648KXN__"